import React from "react";
import { Card, CardContent } from "../../components/ui/card";
import { Skeleton } from "../../components/ui/skeleton";

export default function HeroSkeleton() {
    return (
        <section className="">
            <Card className="overflow-hidden bg-gradient-to-r from-[hsl(var(--card))] to-[hsl(var(--alt-bg))] border border--border">
                <CardContent className="p-0">
                    <div className="flex flex-col sm:flex-row">
                        {/* Left */}
                        <div className="flex-1 p-5 relative">
                            <div className="flex items-center gap-2">
                                <Skeleton className="h-5 w-16 rounded" />
                                <Skeleton className="h-4 w-40 rounded" />
                            </div>

                            <div className="mt-4 space-y-2">
                                <Skeleton className="h-7 w-56 rounded" />
                                <Skeleton className="h-7 w-40 rounded" />
                            </div>

                            <div className="mt-10 flex items-center gap-2">
                                <Skeleton className="h-4 w-4 rounded-full" />
                                <Skeleton className="h-4 w-48 rounded" />
                            </div>

                            <div className="mt-4 flex gap-2">
                                <Skeleton className="h-9 w-28 rounded" />
                                <Skeleton className="h-9 w-28 rounded" />
                            </div>
                        </div>

                        {/* Right (snabbstatistik) */}
                        <div className="sm:w-72 p-5 border-t sm:border-l border-[hsl(var(--border))] bg-[hsl(var(--alt-bg))]">
                            <Skeleton className="h-3 w-28 rounded" />
                            <div className="mt-3 grid grid-cols-3 gap-2">
                                {[...Array(3)].map((_, i) => (
                                    <div key={i} className="rounded-md bg-[hsl(var(--card))] p-3 text-center">
                                        <Skeleton className="h-3 w-16 mx-auto mb-2 rounded" />
                                        <Skeleton className="h-6 w-10 mx-auto rounded" />
                                        <Skeleton className="h-3 w-12 mx-auto mt-2 rounded" />
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </CardContent>
            </Card>
        </section>
    );
}
